import { useTranslations } from "next-intl";
import { useIsShopsite } from "@context/DomainContext";
import { Button, Heading } from "@components/theming";

export default function EventTicketButton({
  showEventDescription,
  href,
  priceText,
}: {
  showEventDescription?: boolean;
  href: string;
  priceText?: string;
}) {
  const isShopsite = useIsShopsite();
  const t = useTranslations("EventPage");

  return (
    <>
      <Button
        href={href}
        whitelabelVariant="soft"
        size="3"
        whitelabelClasses="w-full md:mt-4"
        shopsiteClasses="w-full md:w-2/3"
      >
        {showEventDescription
          ? isShopsite
            ? t("gettickets")
            : t("buytickets")
          : t("showdetails")}
      </Button>
      {priceText && (
        <Heading
          as="h2"
          shopsiteClasses="md:w-1/3 text-gray-500 text-base leading-7"
        >
          {priceText}
        </Heading>
      )}
    </>
  );
}
